import { call, put, takeEvery } from 'redux-saga/effects';
import { setMonHocList, setMonHocStatus, insertMonHocSuccess } from './monHocSlice';
import { MonHocService } from '../../services/mon-hoc/monHocService';
import { ExecuteResultStatus } from '../../services/base-model/ExecuteResultDto';

function* loadMonHoc(): Generator<any, void, any> {
    try {
        const data = yield call(MonHocService.getAll);
        yield put(setMonHocList(data));
    } catch (e) {
        yield put(setMonHocStatus(ExecuteResultStatus.Error));
    }
}

function* createMonHocSaga(action: { type: string; payload: any }): Generator<any, void, any> {
    try {
        const data = yield call(MonHocService.createOrEdit, action.payload);
        if (data.status === ExecuteResultStatus.Success) {
            yield put(insertMonHocSuccess(data.data));
        } else {
            yield put(setMonHocStatus(data.status));
        }
    } catch (e) {
        yield put(setMonHocStatus(ExecuteResultStatus.Error));
    }
}
function* deleteMonHocSaga(action: { type: string; payload: number }): Generator<any, void, any> {
    try {
        const data = yield call(MonHocService.delete, action.payload);
        if (data.status === ExecuteResultStatus.Success) {
            yield put(setMonHocStatus(ExecuteResultStatus.Success));
        } else {
            yield put(setMonHocStatus(data.status));
        }
    } catch (e) {
        yield put(setMonHocStatus(ExecuteResultStatus.Error));
    }
}
function* updateMonHocSaga(action: { type: string; payload: any }): Generator<any, void, any> {
    try {
        const data = yield call(MonHocService.update, action.payload);
        if (data.status === ExecuteResultStatus.Success) {
            yield put(setMonHocStatus(ExecuteResultStatus.Success));
        } else {
            yield put(setMonHocStatus(data.status));
        }
    } catch (e) {
        yield put(setMonHocStatus(ExecuteResultStatus.Error));
    }
}
export function* monHocSaga() {
    yield takeEvery('monHoc/loadMonHoc', loadMonHoc);
    yield takeEvery('monHoc/createMonHoc', createMonHocSaga);
    yield takeEvery('monHoc/deleteMonHoc', deleteMonHocSaga);
    yield takeEvery('monHoc/updateMonHoc', updateMonHocSaga);
}
